import { localizeCompactNumber, localizeNumber, localizePercent } from './l10n';

// @deprecated: use `localizeNumber` from `utils/i18n`
export const localize = (val: number | string, locale?: string) =>
  typeof val === 'number' ? localizeNumber(val, locale) : val;

// @deprecated: use `localizeCompactNumber` from `utils/i18n`
export const compactNumber = localizeCompactNumber;

// @deprecated: use `localizePercent` from `utils/i18n`
export const formatAsPercent = (num: number, decimalPlace = 2) =>
  localizePercent(num, decimalPlace);

// @deprecated: use `localizePercent` from `utils/i18n`
export const formatTrimmedPercent = (percent: number) => localizePercent(percent);
/** returns boolean if the given value is 0 */
export const isNumberZero = (value?: unknown): value is 0 => Number(value) === 0;

export const formatNumberAsOrdinal = (num: number) => {
  const oneDigit = num % 10;
  const twoDigits = num % 100;
  // for all numbers ending in 1 and not ending in 11
  if (oneDigit === 1 && twoDigits !== 11) {
    return `${num}st`;
  }
  // for all numbers ending in 2 and not ending in 12
  if (oneDigit === 2 && twoDigits !== 12) {
    return `${num}nd`;
  }
  // for all numbers ending in 3 and not ending in 13
  if (oneDigit === 3 && twoDigits !== 13) {
    return `${num}rd`;
  }
  return `${num}th`;
};
